import Backbone from 'backbone'
import template from './toggles-test.hbs'
import OnOffToggler from 'scoreboard/components/on-off-toggle'

var ColorsTestView = Backbone.View.extend({

	className: 'admin table-hack display-layout admin-test-view admin-test-toggles',

	render: function () {
		this.$el.empty().append(template())
		this.$('.on-off-toggle-container').append(new OnOffToggler({ name: 'onOffToggle' }).render().el)
		this.$('.on-off-toggle-container-two').append(new OnOffToggler({ name: 'onOffToggle2' }).render().el)
		this.$('.on-off-toggle-container-two .on-off-toggle').addClass('toggle-mini')
		this.$('.on-off-toggle-container-three').append(new OnOffToggler({ name: 'onOffToggle3' }).render().el)
		this.$('.on-off-toggle-container-three input').attr('disabled', true)
		this.$('.on-off-toggle-container-four').append(new OnOffToggler({ name: 'onOffToggle4' }).render().el)
		this.$('.on-off-toggle-container-four .on-off-toggle').addClass('toggle-mini')
		this.$('.on-off-toggle-container-four input').attr('disabled', true)
		this.$('.on-off-toggle-container-five').append(new OnOffToggler({ name: 'onOffToggle5' }).render().el)
		this.$('.on-off-toggle-container-five input')
			.attr('disabled', true)
			.attr('checked', true)
		this.$('.on-off-toggle-container-six').append(new OnOffToggler({ name: 'onOffToggle6' }).render().el)
		this.$('.on-off-toggle-container-six .on-off-toggle').addClass('toggle-mini')
		this.$('.on-off-toggle-container-six input')
			.attr('disabled', true)
			.attr('checked', true)
		this.$('.on-off-toggle-container-seven').append(new OnOffToggler({ name: 'onOffToggle7', label: 'This toggle has a label' }).render().el)
		this.$('.on-off-toggle-container-eight').append(
			new OnOffToggler({
				name: 'onOffToggle8',
				label: 'This toggle has an error and a label'
			}).render().el
		)
		this.$('.on-off-toggle-container-eight input').attr('checked', true)
		this.$('.on-off-toggle-container-eight input').addClass('has-error')

		return this
	}
})

export default ColorsTestView
